import classnames from 'classnames';
import css from '../GridComponent.module.scss';
import GridTable from '../../components/GridTable/GridTable';
import React, { useRef } from 'react';
import { generateStylers } from '../../../../common/utils/styles';

const FixedLastColumnGridComponent = ({
    gridStyles,
    gridName,
    gridWrapper,
    sticky,
    fullScreen,
    classes,
    stylers,
    variant,
    tableProps,
    viewData,
    tableData,
    viewThead,
    isMobile,
    tableThHeight,
    tableTrHeights,
    isFixedLastColumnShow,
    fixedLastColumnShow
}) => {
    const refTableFixed = useRef(null);
    const refTableFixedChild = useRef(null);

    const gridFixedLastColumn = generateStylers(gridStyles?.gridFixedLastColumn);
    return (
        <div className={classnames(css.fixedLast, gridFixedLastColumn?.className)}>
            <div
                id={`${gridName}-lastportalDropdown`}
                style={{
                    ...gridWrapper.style,
                    ...gridFixedLastColumn?.wrapper?.style,
                    ...(!fixedLastColumnShow ? { display: 'none' } : {})
                }}
                className={classnames({ 'sticky-table-fullscreen': sticky && fullScreen }, css.gridWrapper, gridWrapper.style)}
                ref={refTableFixed}
            >
                <div
                    className={classnames(
                        'custom-scroll',
                        gridStyles?.tableWrapper
                            ? [css.gridWrapperBorderRadius, classes.wrapper]
                            : [css.gridWrapperOverflow, css.gridWrapperBorderRadius]
                    )}
                    ref={refTableFixedChild}
                    style={
                        gridStyles?.tableWrapper
                            ? { ...stylers?.wrapper }
                            : {
                                  ...(sticky
                                      ? {
                                            ...(fullScreen && {
                                                maxHeight: `calc((var(--vh, 1vh) * 100) - ${variant === 1 ? '116' : '164'}px)`
                                            })
                                        }
                                      : {})
                              }
                    }
                >
                    <GridTable
                        sticky={sticky}
                        {...tableProps}
                        refTable={refTableFixed}
                        refTableChild={refTableFixedChild}
                        gridName={`${gridName}-last`}
                        viewData={{
                            ...viewData,
                            data: viewData?.data?.map((el) => ({
                                [sticky?.rightStickyColumnName]: el?.[sticky?.rightStickyColumnName],
                                ...el
                            }))
                        }}
                        tableData={{
                            ...tableData,
                            data: tableData?.data?.map((el) => ({
                                [sticky?.rightStickyColumnName]: el?.[sticky?.rightStickyColumnName],
                                ...el
                            }))
                        }}
                        viewThead={{
                            ...viewThead,
                            data: [viewThead?.data[viewThead?.data?.length - 1]].map((el) => {
                                return {
                                    ...el,
                                    ...(isMobile ? { title: '' } : {})
                                };
                            })
                        }}
                        isFixedColumn={true}
                        tableTrHeights={tableTrHeights}
                        tableThHeight={tableThHeight}
                        isFixedLastColumnShow={isFixedLastColumnShow}
                    />
                </div>
            </div>
        </div>
    );
};

export default FixedLastColumnGridComponent;
